import React from 'react';
import Link from 'gatsby-link';
import Carousel from '../components/carousel';
import ContactForm from '../components/contact_form';
import scrollToPlugin from 'gsap/ScrollToPlugin';
import "core-js/fn/symbol/iterator.js";

import bell_interior_01_1000 from '../assets/img/bell-interior-01_1000.jpg';
import bell_interior_01_800 from '../assets/img/bell-interior-01_800.jpg';

import carouselSlides from '../data/carouselSlides';

import './index.scss';

class IndexPage extends React.Component {
  componentDidMount() {
    const ScrollMagic = require('ScrollMagic');
    require('animation.gsap');
    require('TweenMax');

    this.controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
      triggerElement: '.hero'
    })
      .setTween(TweenMax.fromTo('.hero .right-image', 1, {opacity: 0}, {opacity: 1, delay: 0.5}))
      .reverse(false)
      .addTo(this.controller);

    new ScrollMagic.Scene({
      triggerElement: '.team',
      offset: -300,
    })
      .setTween(TweenMax.fromTo('.team .headline-image', 1, {opacity: 0}, {opacity: 1}))
      .reverse(false)
      .addTo(this.controller);

    const fadeInElements = document.getElementsByClassName('fade-in');
    for (let el of fadeInElements) {
      new ScrollMagic.Scene({
            triggerElement: el,
            offset: -300,
          })
      .setTween(TweenMax.fromTo(el, 1, {opacity: 0, transform: 'translateX(-40px)'}, {opacity: 1, transform: 'translateX(0)', delay: 0.2}))
      .reverse(false)
      .addTo(this.controller);      
    };
  }

  componentWillUnmount() {
    this.controller.destroy();
  }

  clickContactButton(e) {
    e.preventDefault();
    const el = document.getElementById('contact');

    TweenLite.to(window, .8, {
      scrollTo: {y: el},
      ease: Power2.easeOut
    });
  }

  render() {
    return (
      <div>
        <div className="hero">
          <div className="absolute">
            <div className="copy-block fade-in">
              <h2 className="title">Serving the UP for more than 30 years</h2>
              <p className="copy">
                JP Electric Professionals provides Marquette, MI and surrounding areas with 
                services ranging in scope from routine repairs and remodels to residential and 
                commercial new construction.
              </p>
              <a className="btn" href="#contact" onClick={this.clickContactButton}>Contact us +</a>
            </div>
          </div>
          <div className="left-image">
          
          </div>
          <div className="right-image" />
        </div>

        <div id="about" className="about target container page-padding">
          <div className="cols">
            <div className="description fade-in">
              <div>
                <h2 className="background-jp">JP</h2>
                <h2 className="title">Established in 1986</h2>
                <p className="copy about-copy">
                  As owner and Master Electrician, John Prince has put more than 44 years into 
                  the electrical industry. His pride for the Upper Peninsula community is matched 
                  by his desire to offer quality service to all customers.
                </p>
              </div>
            </div>
          </div>
          <div className="cols bullet-points">
            <div className="bullet-point fade-in first"><span>Member of the National Electrical Contractor Association (NECA)</span></div>
            <div className="bullet-point fade-in second"><span>Signatory with the Electricians Local Union 1070</span></div>
          </div>
        </div>

        <div className="team">
          <img className="headline-image" src={bell_interior_01_1000} srcSet={bell_interior_01_1000 + ' 1000w,' + bell_interior_01_800 + ' 800w'} />
          <div className="container">
            <div className="background">
              <div className="cols">
                <div className="headline-container">
                  <p className="headline fade-in">
                    We specialize in residential, commercial, design, maintenance, remodeling,
                    and installation
                  </p>
                </div>
              </div>
              <div className="staff">
                <div className="cols">
                  <h2 className="title"></h2>
                  <p className="copy fade-in">
                    Licensed, bonded and insured, JP Electric employs trained and skilled electricians -
                    journeymen who have been with the company between 10 and 40 years, and apprentices 
                    who are enrolled in a national certified 5-year program. All strive to provide the 
                    best possible service for total customer satisfaction. 
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="past-work" className="projects target">
          <div className="container">
            <div className="background">
              <div className="cols">
                <h2 className="title">Past projects</h2>
              </div>
            </div>
          </div>
          <Carousel slideData={carouselSlides} />
        </div>

        <ContactForm />
      </div>
    );
  }
}

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js